import { useTranslation } from 'react-i18next';
import { PurchaseInvoiceStatus } from '@optiflow/types';
import { Badge } from '@/components/ui/Badge';

type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'brand';

/**
 * A supplier invoice has only two states, and they mean opposite things about money.
 *
 * Posted is an obligation the business has recognised, so it carries the brand colour rather than
 * a success tone: owing someone is not an achievement. Voided is quiet — the document is still
 * there, but it asks for nothing.
 */
const TONES: Record<PurchaseInvoiceStatus, Tone> = {
  [PurchaseInvoiceStatus.POSTED]: 'brand',
  [PurchaseInvoiceStatus.VOIDED]: 'neutral',
};

export function PurchaseInvoiceStatusBadge({ status }: { status: PurchaseInvoiceStatus }) {
  const { t } = useTranslation();

  return (
    <Badge tone={TONES[status] ?? 'neutral'}>{t(`purchasing.invoices.status.${status}`)}</Badge>
  );
}
